import { ChannelkartNetworkGet } from "./networkService";

const DISTRIBUTOR_HIERARCHY_ENDPOINT =
  "/users/mapped/hierarchy?filter=activeStatus%3Aactive%20and%20designation%5Bin%5D%3A%5Bsupplier%5D&size=10000";

export interface DistributorFeature {
  id: string;
  loginId: string;
  prodauthcode?: string;
  extendedAttributes?: {
    distributorType?: string;
    distType?: string;
    [key: string]: any;
  };
  [key: string]: any;
}

export interface DistributorMeta {
  types: string[];
  divisions: string[];
  features: DistributorFeature[];
}

const parseDivisionCodes = (feature: DistributorFeature): string[] => {
  if (!feature?.prodauthcode) {
    return [];
  }
  return feature.prodauthcode
    .split(",")
    .map(code => code.trim())
    .filter(Boolean);
};

export const fetchDistributorMeta = async (): Promise<DistributorMeta> => {
  const response = await ChannelkartNetworkGet(DISTRIBUTOR_HIERARCHY_ENDPOINT);
  const features: DistributorFeature[] = Array.isArray(response?.data?.features)
    ? response.data.features
    : [];

  const divisionSet = new Set<string>();
  const typeSet = new Set<string>();

  features.forEach(feature => {
    parseDivisionCodes(feature).forEach(code => divisionSet.add(code));
    const distributorType = feature?.extendedAttributes?.distType;
    if (distributorType) {
      typeSet.add(distributorType);
    }
  });

  return {
    features,
    divisions: Array.from(divisionSet).sort(),
    types: Array.from(typeSet).sort(),
  };
};

export const filterDistributorsBySelections = (
  features: DistributorFeature[],
  selectedTypes: string[],
  selectedDivisions: string[],
  allowedLoginIds?: string[]
): string[] => {
  let matched = features;

  if (selectedTypes.length > 0) {
    matched = matched.filter(feature => {
      const distributorType = feature?.extendedAttributes?.distType;
      return distributorType ? selectedTypes.includes(distributorType) : false;
    });
  }

  if (selectedDivisions.length > 0) {
    matched = matched.filter(feature => {
      const codes = parseDivisionCodes(feature);
      return codes.some(code => selectedDivisions.includes(code));
    });
  }

  const loginIds = matched
    .map(feature => feature.loginId)
    .filter((id): id is string => Boolean(id));

  if (allowedLoginIds && allowedLoginIds.length > 0) {
    return allowedLoginIds.filter(id => loginIds.includes(id));
  }

  return loginIds;
};


